import React, { useEffect, useMemo, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner, Input } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAuthUser } from "../../../helpers/utils";
import { useDispatch, useSelector } from "react-redux";
import { fetchReferralRewardTableColumnNames, fetchAllReferralReward, createReferralReward, updateReferralReward, 
    deleteReferralReward, activateDeactivateReferralReward, updateUserPreference,
    fetchTranslation,
    fetchCountry,
    fetchUsersByRoleID} from "../../../slices/thunks";
import ColumnSelectionModal from "../../../Components/Common/ColumnSelectionModal/ColumnSelectionModal";
import CommonTable from "../../../Components/Common/Table/CommonTable";
import DeleteModal from "../../../Components/Common/DeleteModal";
import AddModal from "../../../Components/Common/Modal/AddModal";
import AddCommonForm2 from "../../../Components/Common/AddCommonForm/AddCommonForm2";
import AddReferralRewardForm from "../../../Components/Common/AddReferralRewardForm/AddReferralRewardForm";
import CommonAddModal from "../../../Components/Common/Modal/CommonAddModal";
import CommonDataTable from "../../../Components/Common/Table/CommonDataTable";
import usePermissions from "../../../Components/Hooks/usePermissions";
import { fetchAllReferralEarn, fetchAllReferralStatus, fetchReferralEarnTableColumnNames, updateReferral } from "../../../slices/referralEarn/thunk";
// import { t } from "i18next"; // This is redundant, useTranslation hook already provides t
import TableSummary from "../../../Components/Common/TableSummary/TableSummary";
import ApplyReferralModal from "../../../Components/Common/Modal/ApplyReferralModal";
// import TableSummary from "../../../Components/Common/Table/TableSummary";


const labels = [
  {
    id: 1,
    labelName: "Referral Name English",
    fieldName: "text-box-translate",
    name: "ReferralNameEn",
    value: "ReferralNameEn",
    required: true,
    translateTo: "ReferralNameAr", 
    errorMessage:"Referral English Is Required",
  },
  {
    id: 2,
    labelName: "Referral Name Arabic",
    fieldName: "text-box",
    name: "ReferralNameAr",
    value: "ReferralNameAr",
    required: true,
    errorMessage:"Referral Arabic Is Required",
  },
  {
    id: 3,
    labelName: "Cash",
    fieldName: "number-box",
    name: "Cash",
    value: "Cash",
    required: true,
    errorMessage:"Cash Is Required",
  },
  {
    id: 4,
    labelName: "Voucher",
    fieldName: "number-box",
    name: "Voucher",
    value: "Voucher",
    required: true,
    errorMessage:"Voucher Is Required",
  },
  {
    id: 5,
    labelName: "Coin",
    fieldName: "number-box",
    name: "Coin",
    value: "Coin",
    required: true,
    errorMessage:"Coin Is Required",
  },
  {
    id: 6,
    labelName: "Referend Amount",
    fieldName: "number-box",
    name: "ReferendAmount",
    value: "ReferendAmount",
    required: true,
    errorMessage:"Referend Amount Is Required",
  },
   {
    id: 7,
    labelName: "Countries",
    fieldName: "multiselect-dropdown",
    name: "CountryIDs",
    value: "CountryIDs",
    required: true,
    errorMessage:"Days are Required",
  },
  {
    id: 8,
    labelName: "Referral Document",
    fieldName: "file",
    name: "DocumentURL",
    value: "DocumentURL",
    required: true,
    errorMessage: "Please Select Document",
  },
  {
    id: 9,
    labelName: "Percentage",
    fieldName: "check-box",
    name: "IsPercentage",
    value: "IsPercentage",
    required: false,
  }
]

const actionConfig = {
  apply: {
    icon: "ri-gift-line", 
    tooltip: "ApplyReferral", // Tooltip should be a key for translation, or already translated string
    isVisible: (item, permission) => {
      return permission?.CanEdit; 
    }
  },
};


function ReferralEarn () {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const user = getAuthUser();
  const [show, setShow] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddOrEdit, setIsAddOrEdit] = useState("isAdd");
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [lastTranslatedField, setLastTranslatedField] = useState(null);
  const [applyModalOpen, setApplyModalOpen] = useState(false);
  const [selectedReferralItem, setSelectedReferralItem] = useState(null);




const { referralEarnData, tableColumnNames, loading, Headerload } = useSelector((state) => ({
    referralEarnData: state.ReferralEarn.referralEarnData,
    tableColumnNames: state.ReferralEarn.tableColumnNames,
    loading: state.ReferralEarn.loading,
    Headerload: state.ReferralEarn.Headerload,
  }));

  const summaryItems = useMemo(() => {
    if (referralEarnData?.Summary) {
      return Object.entries(referralEarnData.Summary).map(([key, value]) => ({
        label: key, 
        value: value,
      }));
    }
    return [ // Default or fallback summary items
      { label: "TotalReferrals", value: 0 },
      { label: "TotalCoinDistribution", value: 0 },
      { label: "TotalReferralsEnrolled", value: 0 },
    ];
  }, [referralEarnData?.Summary]);




  // Compute permission
  const permission = (() => {
    return usePermissions(9, 21);
  })();

  
  const onSubmitHandler = (values, { resetForm, setSubmitting }) => {

    const referralRewardObj = {
      ReferralNameEn: values.ReferralNameEn,
      ReferralNameAr: values.ReferralNameAr,
      Cash: values.Cash,
      Voucher: values.Voucher, 
      Coin: values.Coin, 
      ReferendAmount: values.ReferendAmount,
      CountryIDs: values.CountryIDs,
      DocumentURL: values.DocumentURL,
      IsPercentage: values.IsPercentage,
    };

    if (isAddOrEdit === "isEdit") {
        referralRewardObj.ID = selectedRow?.ID;
    }

    isAddOrEdit === "isAdd" ?
      dispatch(createReferralReward(referralRewardObj)) :
      dispatch(updateReferralReward(referralRewardObj));

    resetForm();
    setShow(false);
  };

  const handleSave = async () => {
    const preferencesPayload = {
      UserId: user.UserId,
      ColumnIDs: tableColumnNames.reduce((acc, column) => {
        acc[column.ColumnId] = selectedColumns.includes(column.ColumnId);
        return acc;
      }, {}),
    };

    setModalOpen(false);
    try {
      await dispatch(updateUserPreference(preferencesPayload)).unwrap();
      await dispatch(
        fetchReferralRewardTableColumnNames({
          module: "REFERRALREWARD"
        })
      );

    } catch (error) {
      console.error("Error updating preferences:", error);
    }
  };

    const onSubmitReferral = (item, title, inputValue) => {
    
     const Obj = {
      ID: item.ID, 
      [title]: inputValue
    }

    dispatch(updateReferral(Obj))
    
  };
  
  const handleApplyReferralClick = (item) => {    
    setSelectedReferralItem(item);
    setApplyModalOpen(true);
  };

  const handleApplyModalSubmit = (inputValue) => { // Corrected: Expects a single argument from the modal
    if (selectedReferralItem) {
      const Obj = {
        ID: selectedReferralItem.ID,
        Coin: inputValue, // Assuming the modal input is for the 'Coin' field
      };
      dispatch(updateReferral(Obj));
    }
    setApplyModalOpen(false);
    setSelectedReferralItem(null);
  }

  
  useEffect(() => {
    dispatch(fetchReferralEarnTableColumnNames({ module: "REFERRALEARN" }))
    dispatch(fetchAllReferralEarn());
    dispatch(fetchCountry());
    // Role : Referral Manager (155)
    dispatch(fetchUsersByRoleID({RoleId: 155}));
    dispatch(fetchAllReferralStatus());
  }, [dispatch]);

  return (
    <div className="page-content">
      <Container fluid>
        <Row className="mb-3">
          <Col>
            <BreadCrumb title={t("ReferralEarn")} />
          </Col>
        </Row>
        <Card>
          <CardBody>
            <TableSummary summaryItems={summaryItems} />
          </CardBody>
        </Card>
        <div className="table-responsive">
          <Card>
            <CardHeader>
                <Row className="g-4">
                  <Col className="col-sm-auto">
                    <div>
                      <Button
                        className="btn btn-soft-danger ms-2 me-2"
                        onClick={() => setDeleteModal(true)}
                        disabled={selectedIds.length === 0}
                      >
                        <i className="ri-delete-bin-2-line"></i>
                      </Button>
                      {/* {permission.CanAdd && (
                        <Button
                          color="secondary"
                          className="add-btn me-1"
                          onClick={() => onAddClickHandler("isAdd")}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1 ms-1"></i>
                          {t("AddNew")}
                        </Button>
                      )} */}
                    </div>
                  </Col>
                  <Col className="col-sm">
                    <div className="d-flex justify-content-sm-end">
                      <Button
                        className="btn btn-soft"
                        onClick={() => setModalOpen(true)}
                      >
                        <i className="ri-filter-3-line"></i>
                      </Button>
                      <div className="search-box ms-2 me-2">
                        <Input
                          type="text"
                          className="form-control search"
                          placeholder={t("Search")}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="ri-search-line search-icon"></i>
                      </div>
                    </div>
                  </Col>
                </Row>
            </CardHeader>

            <CardBody>
              <div className="listjs-table" id="customerList">
                {loading || Headerload ? (
                  <div className="d-flex justify-content-center align-items-center">
                  <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                    Loading...
                  </Spinner>
                  </div>
                ) : (
                  <div className="listjs-table" id="customerList">
                     <CommonDataTable
                        data={referralEarnData.ReferredUsersList || []}
                        tableColumnNames={tableColumnNames || []}
                        onInlineUpdate={onSubmitReferral}
                        searchTerm={searchTerm}
                        actionConfig={actionConfig}
                        permission={permission}
                        onApplyClick={handleApplyReferralClick}
                     />
                  </div>
                )}
              </div>
            </CardBody>
          </Card>
        </div>
      </Container>

      {/* Modal 
       <CommonAddModal
            show={show}
            setShow={setShow}
            onSubmitHandler={onSubmitHandler}
            labels={labels}
            isAddOrEdit={isAddOrEdit}
            selectedItemData={selectedRow} 
            FormBody={AddReferralRewardForm}
            FormBodyProps={{ 
              onTranslateClickHandler, 
              translationLoading,
              lastTranslatedField,
              setParentSubmitDisabled: setIsDisabled, 
            }}
            title={isAddOrEdit === "isAdd" ? t("Add New Referral Reward") : t("Edit Referral Reward")}
            size="xl" 
            isDisabled={isDisabled} 
        /> */}

      {/* Apply Referral Modal */}
      <ApplyReferralModal
        isOpen={applyModalOpen}
        toggle={() => { setApplyModalOpen(false); setSelectedReferralItem(null);}}
        onSubmit={handleApplyModalSubmit}
        referralItemName={selectedReferralItem?.FullName} 
        initialValue={200} 
      />


      {/* ColumnSelectionModal */}
      <ColumnSelectionModal
        isOpen={modalOpen}
        toggle={() => setModalOpen(!modalOpen)}
        columns={tableColumnNames}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        handleSave={handleSave}
      />

      {/* Delete modal  */}
      {/* <DeleteModal
        showDelete={deleteModal}
        setShowDelete={setDeleteModal}
        onDeleteClick={confirmDelete}
        setSelectedIds={setSelectedIds}
        description={`Are you sure you want to delete this record?`}
      /> */}
    </div>
  );
}

export default ReferralEarn;